document.addEventListener('DOMContentLoaded', function () {

  const customMenu = document.getElementById('mobileMenu');
  const closeBtn = document.getElementById('closeMenu');

  // Try all possible Horizon menu buttons
  const menuButtons = document.querySelectorAll(
    '.header__icon--menu, .header__menu-toggle, button[aria-label="Menu"], button[aria-controls="menu-drawer"]'
  );

  menuButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Close theme menu if it exists
      const themeDrawer = document.querySelector('#menu-drawer, .menu-drawer');
      if (themeDrawer) {
        themeDrawer.classList.remove('open', 'active');
        themeDrawer.style.display = 'none';
      }

      // Open custom menu
      if (customMenu) {
        customMenu.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      if (customMenu) {
        customMenu.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }
  // Close menu when clicking outside
  document.addEventListener('click', function (e) {
    if (!customMenu) return;

    const isMenuOpen = customMenu.classList.contains('open');
    const clickedInsideMenu = customMenu.contains(e.target);

    if (isMenuOpen && !clickedInsideMenu) {
      customMenu.classList.remove('open');
      document.body.style.overflow = '';
    }
  });


});
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('comboSlider');
  if (!slider) return;

  let index = 0;
  const slides = slider.querySelectorAll('.combo-slide');
  if (!slides.length) return;

  const slideWidth = () => slides[0].offsetWidth + 12; // 12px gap

  setInterval(() => {
    index = (index + 1) % slides.length;
    slider.scrollTo({
      left: index * slideWidth(),
      behavior: 'smooth'
    });
  }, 3000);
});
/*------------------*/

(function () {

  function initBundle() {
    const bundleBox = document.getElementById('bundleBox');
    const hidden = document.getElementById('bundleSelectedId');
    const form = document.querySelector('form[action^="/cart/add"]');

    if (!bundleBox || !hidden || !form) return;

    const cards = bundleBox.querySelectorAll('.bundle-item.selectable');

    // Get Shopify's real variant input
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    // DEFAULT = combo
    const combo = bundleBox.querySelector('.bundle-item.main-product');
    if (combo) {
      combo.classList.add('active');
      variantInput.value = combo.dataset.id;
      hidden.value = combo.dataset.id;
    }

    // CLICK = UPDATE VARIANT INPUT IMMEDIATELY
    bundleBox.addEventListener('click', function (e) {
      const card = e.target.closest('.bundle-item.selectable');
      if (!card) return;

      cards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      const id = card.dataset.id;
      if (id) {
        hidden.value = id;
        variantInput.value = id; // THIS IS THE KEY FIX
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initBundle);
  document.addEventListener('shopify:section:load', initBundle);

})();
function runRatingSort(mode) {
  const grid =
    document.querySelector('.product-grid') ||
    document.querySelector('.grid') ||
    document.querySelector('.card-gallery');

  if (!grid) return;

  const cards = Array.from(grid.children);

  cards.sort((a, b) => {
    const ra =
      parseFloat(
        a.querySelector('.jdgm-prev-badge__stars')
          ?.getAttribute('data-score')
      ) || 0;

    const rb =
      parseFloat(
        b.querySelector('.jdgm-prev-badge__stars')
          ?.getAttribute('data-score')
      ) || 0;

    return mode === 'desc' ? rb - ra : ra - rb;
  });

  cards.forEach(card => grid.appendChild(card));
}

/* STOP SHOPIFY DEFAULT SORT */
document.addEventListener('click', function(e) {
  const option = e.target.closest('.sorting-filter__option');
  if (!option) return;

  const input = option.querySelector('input[name="sort_by"]');
  if (!input) return;

  if (input.value === 'rating-desc' || input.value === 'rating-asc') {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (input.value === 'rating-desc') runRatingSort('desc');
    if (input.value === 'rating-asc') runRatingSort('asc');

    // Visually mark selected
    document
      .querySelectorAll('.sorting-filter__option')
      .forEach(opt => opt.classList.remove('is-active'));
    option.classList.add('is-active');
  }
}, true);
document.addEventListener("variant:change", function(e) {
  const variant = e.detail.variant;
  if (!variant) return;

  const badge = document.querySelector('[id^="discountBadge"]');
  if (!badge) return;

  if (variant.compare_at_price > variant.price) {
    const discount = Math.round(
      ((variant.compare_at_price - variant.price) * 100) /
      variant.compare_at_price
    );

    badge.textContent = `${discount}% OFF`;
    badge.style.display = "inline-block";
  } else {
    badge.style.display = "none";
  }
});


(function () {
  function moveBadge(root = document) {
    // loop each product card so badge goes to its own price section
    const cards = root.querySelectorAll('product-card.product-card');

    cards.forEach(card => {
      const badge = card.querySelector('.product-card__discount-badge');
      const priceSec = card.querySelector('.price-main-sec');

      if (badge && priceSec && badge.parentElement !== priceSec) {
        priceSec.appendChild(badge); // move
      }
    });
  }

  // run once now
  moveBadge(document);

  // observe changes because Shopify sections/components re-render
  const obs = new MutationObserver(mutations => {
    for (const m of mutations) {
      // if new nodes are added, try moving badge in that subtree
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) moveBadge(node);
      });
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

/*-------------------------------*/
document.addEventListener("DOMContentLoaded", function(){

  function getDaySuffix(day){
    if(day > 3 && day < 21) return "th";
    switch(day % 10){
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  function formatSingleDate(date){
    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getDate();
    return month + " " + day + getDaySuffix(day);
  }

  function formatRangeDate(start, end){
    const month = start.toLocaleString('en-US', { month: 'short' });
    const startDay = start.getDate();
    const endDay = end.getDate();

    return month + " " + startDay + getDaySuffix(startDay) + 
           "–" + endDay + getDaySuffix(endDay);
  }

  const today = new Date();

  // Order placed = today
  document.getElementById("orderDate").innerText = formatSingleDate(today);

  // Shipping = today to +1 day
  let shipStart = new Date();
  let shipEnd = new Date();
  shipEnd.setDate(today.getDate() + 1);

  document.getElementById("shipDate").innerText = 
    formatRangeDate(shipStart, shipEnd);

  // Delivery = +3 to +5 days
  let deliveryStart = new Date();
  deliveryStart.setDate(today.getDate() + 3);

  let deliveryEnd = new Date();
  deliveryEnd.setDate(today.getDate() + 5);

  document.getElementById("deliveryDate").innerText =
    formatRangeDate(deliveryStart, deliveryEnd);

});
/*--------------------*/
document.addEventListener("DOMContentLoaded",function(){

  const openBtn = document.getElementById("openBulkPopup");
  const popup = document.getElementById("bulkPopup");
  const closeBtn = document.getElementById("closeBulkPopup");

  if(openBtn){
    openBtn.onclick = () => popup.classList.add("active");
  }

  if(closeBtn){
    closeBtn.onclick = () => popup.classList.remove("active");
  }

  popup?.addEventListener("click",(e)=>{
    if(e.target.classList.contains("bulk-popup-overlay")){
      popup.classList.remove("active");
    }
  });

});